import {requestMs} from "@helpers/api";

export const garages = {
  getGarages: (id) => requestMs.get(`/api3/user/${ id }/garage?language=de-DE`)
};
